import React from 'react';
import { useTranslation } from 'react-i18next';
import { topFeatures } from '../../data/features';
import './FeaturesGrid.css';

export const FeaturesGrid: React.FC = () => {
  const { t } = useTranslation();
  // Screen sharing also has its own section above; it stays in the grid so the
  // overview is complete and carries the "Exclusive" badge.
  const featured = topFeatures.filter((f) => f.featured);
  const rest = topFeatures.filter((f) => !f.featured);

  return (
    <section className="features-section" id="features">
      <div className="features-container">
        <div className="features-header">
          <h2>{t('features.header')}</h2>
          <p>{t('features.subheader')}</p>
        </div>

        <div className="featured-row">
          {featured.map((feature) => (
            <div key={feature.id} className="featured-card">
              <span className="featured-icon">{feature.icon}</span>
              <div className="featured-content">
                {feature.unique && <span className="feature-badge">{t('features.exclusive')}</span>}
                <h3 className="featured-title">{t(`features.items.${feature.id}.title`)}</h3>
                <p className="featured-description">{t(`features.items.${feature.id}.description`)}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="compact-grid">
          {rest.map((feature) => (
            <div key={feature.id} className="compact-card">
              <span className="compact-icon">{feature.icon}</span>
              <h3 className="compact-title">{t(`features.items.${feature.id}.title`)}</h3>
              <p className="compact-description">{t(`features.items.${feature.id}.description`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
